import { useMutation } from '@tanstack/react-query';
import { searchJobById } from '../api/queues';

/**
 * Hook for searching a job by ID
 * @returns Mutation for searching a job
 */
export const useSearchJob = () => {
  return useMutation({
    mutationFn: (jobId: string) => searchJobById(jobId)
  });
};
